import { render, staticRenderFns } from "./EmptyProviderComponent.vue?vue&type=template&id=b5210134&"
import script from "./EmptyProviderComponent.vue?vue&type=script&lang=ts&"
export * from "./EmptyProviderComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports